export const scrollToTop = () => {
  const button = document.querySelector('.footer__go-top');

  if (!button) return;

  button.addEventListener('click', (e) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
};